import { css, type Theme } from '@emotion/react';

import { removeButtonAppearance } from '../../../utils/style';
import { TABS_HORIZONTAL_GAP_PX } from './computeMaxVisibleTabsCount';

export const container = (theme: Theme, shouldDisplayBorder: boolean) => css`
  display: flex;
  align-items: flex-end;
  position: relative;
  width: 100%;
  border-bottom: ${shouldDisplayBorder ? `1px solid ${theme.colors.gray[100]}` : ''};
`;

export const verticalContainer = css`
  display: flex;
  height: 100%;
`;

export const measureRow = css`
  position: absolute;
  display: flex;
  align-items: flex-end;
  gap: ${TABS_HORIZONTAL_GAP_PX}px;
  left: 0;
  top: 0;
  white-space: nowrap;
  visibility: hidden;
  pointer-events: none;
`;

export const seeMoreMeasure = css`
  flex-shrink: 0;
`;

export const horizontalTab = (
  theme: Theme,
  hasMultipleTabGroups: boolean,
  shouldDisplayBorder: boolean,
) => css`
  display: flex;
  align-items: flex-end;
  gap: ${TABS_HORIZONTAL_GAP_PX}px;
  border-bottom: ${!shouldDisplayBorder ? `1px solid ${theme.colors.gray[100]}` : ''};
  width: ${!hasMultipleTabGroups ? '100%' : 'auto'};
  white-space: nowrap;
  list-style-type: none;
`;

export const verticalTab = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 10px;
  border-right: 1px solid ${theme.colors.gray[100]};

  list-style-type: none;
`;

export const dragStyle = css`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;

  cursor: grab;

  padding: 2px;
`;

export const seeMore = (theme: Theme) => css`
  ${removeButtonAppearance};
  display: inline-flex;
  align-items: center;
  padding: 7px 0px 7px 20px;
  position: relative;
  gap: 10px;

  &:hover {
    color: ${theme.colors.primary[500]};
  }

  &::before {
    content: "";
    position: absolute;
    bottom: -1px;
    left: 0;
    width: 20px;
    height: 1px;
    background-color: ${theme.colors.gray[100]};
  }

  &::after {
    content: "";
    position: absolute;
    bottom: -1px;
    left: 20px;
    right: 0;
    height: 1px;
    background-color: ${theme.colors.gray[100]};
    transition: background-color 0.3s ease;
  }

  &:hover::after {
    background-color: ${theme.colors.primary[500]};
  }
`;
